<app-tab-menu class="example-tab-view" [orientation]="orientation">
  <app-tab-panel header="Tab 1">Tab 1. orientation="{{ orientation }}"</app-tab-panel>
  <app-tab-panel header="Tab 2">Tab 2. orientation="{{ orientation }}"</app-tab-panel>
  <app-tab-panel header="Tab 3">Tab 3. orientation="{{ orientation }}"</app-tab-panel>
</app-tab-menu>